module.exports = __webpack_public_path__ + "img/jichang.d3166b42.png";